import React, { useEffect, useState } from "react";

const Footer: React.FC = () => {
  // 네비게이션 링크들을 섹션별로 그룹화
  const navigationLinks = {
    section1: [
      { text: "Home", href: "/" },
      { text: "Artwork", href: "/artwork" },
      { text: "Biography", href: "/biography" },
      { text: "Contacts", href: "/contacts" },
      {
        text: "Instagram",
        href: "https://www.instagram.com/leesunhee_1965?igsh=MXF3OWYxc3N4ODBscw==",
      },
    ],
  };

  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // Check if we're at the bottom of the page
      const bottom =
        Math.ceil(window.innerHeight + window.scrollY) >=
        document.documentElement.scrollHeight - 100;

      if (bottom) {
        setIsVisible(true);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <footer
      className={`w-full bg-white py-16 transition-all duration-1500 ease-out${
        isVisible ? "translate-y-0 opacity-100" : "translate-y-full opacity-0"
      }`}
    >
      <div className="mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8">
          {/* Copyright section */}
          <div className="md:col-span-3">
            <h3
              className={`text-xl font-bold transition-colors duration-1000 ${
                isVisible ? "text-gray-800" : "text-white"
              }`}
              style={{
                fontFamily: '"forma-djr-display", sans-serif',
                fontWeight: 800,
                fontSize: "clamp(1rem, 15vw, 2rem)",
                fontStyle: "normal",
              }}
            >
              © LEE SUN HEE
            </h3>
          </div>

          {/* Navigation links section 1 */}
          <div className="md:col-span-1">
            <nav className="flex flex-col">
              {navigationLinks.section1.map((link) => (
                <a
                  key={link.text}
                  href={link.href}
                  className={`text-base font-semibold transition-colors duration-1000 hover:text-gray-600 ${
                    isVisible ? "text-gray-800" : "text-white"
                  }`}
                  style={{
                    fontFamily: '"neue-haas-grotesk-display", sans-serif',
                    fontWeight: 700,
                    fontSize: 17,
                    fontStyle: "normal",
                  }}
                >
                  {link.text}
                </a>
              ))}
            </nav>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
